/**
 * Índice dos pacotes de curso.
 *
 * Junto de `config/courses.ts`, é o único arquivo que muda quando um curso novo
 * chega — nenhuma tela do núcleo precisa saber que ele existe. Os manifestos
 * ficam atrás de import dinâmico de propósito: cada um arrasta o tema, o
 * branding e os loaders das telas daquele curso.
 */

import type { CourseManifest } from './types';

type CourseLoader = () => Promise<{ default: CourseManifest }>;

export const COURSE_PACKAGES: Record<string, CourseLoader> = {
  neurodidatica: () => import('./neurodidatica/manifest'),
  'radiologia-r1': () => import('./radiologia-r1/manifest'),
  'scan-expert': () => import('./scan-expert/manifest'),
  'angio-tc': () => import('./angio-tc/manifest'),
};

export function hasCoursePackage(slug: string): boolean {
  return Object.prototype.hasOwnProperty.call(COURSE_PACKAGES, slug);
}

export function loadCoursePackage(slug: string): Promise<CourseManifest> {
  const load = COURSE_PACKAGES[slug];
  if (!load) {
    return Promise.reject(new Error(`Curso sem pacote registrado: ${slug}`));
  }
  return load().then((mod) => mod.default);
}
